import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDashboard, faClipboardCheck, faCheckCircle, faChartBar, faMoneyCheckAlt, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { useSidebar } from './SidebarContext'; // ✅ Import context

const StudentSidebar = () => {
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { isSidebarOpen } = useSidebar(); // ✅ Use context

  const menuItems = [
    { id: 'dashboard', name: 'Dashboard', icon: faDashboard, path: '/studentmark-dashboard' },
    { id: 'Quiz', name: 'Test', icon: faClipboardCheck, path: '/generate-test' },
    { id: 'completed-test', name: 'Completed Test', icon: faCheckCircle, path: '/completed-Tests' },
    { id: 'results', name: 'Results', icon: faChartBar, path: '/Result' },
    { id: 'payment', name: 'Payment', icon: faMoneyCheckAlt, path: '/Payment-student' },
    { id: 'profile', name: 'My Account', icon: faUserCircle, path: '/profile' }
  ];

  const handleMenuItemClick = (item) => {
    setActiveMenuItem(item.id);
    if (item.path) {
      navigate(item.path);
    }
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const matchedItem = menuItems.find(item => item.path === currentPath);
    if (matchedItem) {
      setActiveMenuItem(matchedItem.id);
    }
  }, [location.pathname]);

  return (
    <div
      className="sidebar"
      style={{
        width: isSidebarOpen ? '250px' : '70px', // ✅ Use context to change width
      }}
    >
      <div className="logo-section">
        <img
          src={isSidebarOpen ? '../images/full-logo.jpeg' : '../images/logo.jpeg'}
          alt="Logo"
          style={{ width: isSidebarOpen ? '110px' : '40px', transition: 'width 0.2s' }}
        />
      </div>

      <div className="menu-section">
        {menuItems.map((item) => (
          <div
            key={item.id}
            className={`sidebar-menu-item ${activeMenuItem === item.id ? 'active' : ''}`}
            onClick={() => handleMenuItemClick(item)}
            style={{ paddingLeft: isSidebarOpen ? '20px' : '0px' }} // ✅ Adjust padding for collapsed state
          >
            <div className="menu-item-content" style={{ gap: isSidebarOpen ? '12px' : '5px' }}>
              <FontAwesomeIcon icon={item.icon} />
              {isSidebarOpen && <span>{item.name}</span>} {/* ✅ Show name only if sidebar is open */}
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .sidebar {
          height: 100vh;
          background-color: #0f172a;
          color: gray;
          position: fixed;
          top: 0;
          left: 0;
          overflow-y: auto;
          transition: width 0.2s ease-in-out;
          box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
          z-index: 1000;
        }

        .logo-section {
          padding: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #1e293b;
        }

        .logo-section img {
          object-fit: contain;
        }

        .menu-section {
          padding: 16px;
        }

        .sidebar-menu-item {
          display: flex;
          align-items: center;
          padding: 10px 16px;
          border-radius: 8px;
          margin-bottom: 5px;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .sidebar-menu-item:hover {
          color: white;
          background-color: #1e293b;
        }

        .sidebar-menu-item.active {
          background-color: #1e293b;
          color: white;
        }

        .menu-item-content {
          display: flex;
          align-items: center;
        }

        @media (max-width: 768px) {
          .sidebar {
            width: 70px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default StudentSidebar;
